function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 12C0 5.374 5.377 0 12.006 0 18.636 0 24 5.374 24 12l-12.006 1.039L0 11.999z",
  fill: "#FFDA44"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.606 18c2.08 3.59 5.956 6 10.4 6 4.442 0 8.318-2.41 10.398-6l-10.399-.78L1.606 18z",
  fill: "#D80027"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.393 18A11.981 11.981 0 0024 12H0c0 2.185.579 4.228 1.607 6h20.786z",
  fill: "#0052B4"
});

function SvgFlagCo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/flag_co.svg";
export { SvgFlagCo as ReactComponent };